<template>
  <table-report
    :value="value"
    :row-header-class="rowHeaderClass"
    :first-column="firstColumn"
    :last-column="firstColumn + visibleColumns - 1">
    <template v-slot:column-header="{ col: c, index: i }">
      <div class="col-2 text-center font-weight-bold border-secondary py-2 border-left"><!-- border-right-->
        <div>
          {{ c.translation || c.name }}
          <b-dropdown size="sm" variant="link" v-if="columnActions && columnActions.length">
            <template v-for="a in columnActions">
              <b-dropdown-item-button @click.prevent="a.action(c, i)">
                {{ a.label }}
              </b-dropdown-item-button>
            </template>
          </b-dropdown>
        </div>
        <tag-list
          v-if="!noTags"
          :value="tagsFor(c)"
          @click="$emit('tag-click', c, i, arguments[0], arguments[1])"
        />
      </div>
    </template>
    <template v-slot:value="{ row, col, index }">
      <div class="col-2 border-secondary border-left d-flex flex-column justify-content-center"><!-- border-right-->
        <div class="row p-0 border-0 align-items-center">
          <i
            v-if="!index && firstColumn > 0 && columns.length > visibleColumns"
            class="fa fa-fw fa-caret-left col-1 p-0"
            style="max-width:20px;cursor:pointer;"
            @click.prevent="previousColumn()"></i>
          <div class="col-5 text-right"
               style="max-width:120px;padding-top:1px;padding-bottom:1px;">
            <delta-percentage
              v-if="showVariation(row, index)"
              :value="computeVariation(row, index)"
            />
          </div>
          <div class="col"
               style="padding-top:1px;padding-bottom:1px;">
            <number-input-field
              v-if="!row.name"
              :disabled="disabled"
              :plaintext="disabled"
            />
            <delta-percentage
              v-else-if="row.options.isDelta"
              component="div"
              class="text-right"
              :value="tableValue(row, col)"
            />
            <number-input-field
              v-else
              :value="tableValue(row, col)"
              :precision="row.options.valuePrecision || 0"
              :append="row.options.valueSuffix"
              :disabled="disabled"
              :plaintext="disabled"
              :input-class="getClass(row, col)"
              @input="valueChanged(row, col, $event)"
            />
          </div>
          <i
            v-if="index === visibleColumns - 1
                  && columns.length > visibleColumns
                  && firstColumn < 1"
            class="fa fa-fw fa-caret-right p-0 col-1"
            style="max-width:20px;cursor:pointer;"
            @click.prevent="nextColumn()"></i>
        </div>
      </div>
    </template>
  </table-report>
</template>
<script>
function classFor(row, col, value) {
  const ret = {
    'text-right': true,
    'font-weight-bold': row.options.bold
  };

  if (value === null || value === undefined) {
    //ret['border border-warning rounded px-2'] = true;
  } else if (isNaN(value)) {
    ret['border border-danger rounded px-2'] = true;
  } else if (value < 0) {
    ret['text-danger'] = true;
  }

  return ret;
}

export default {
  props: {
    value: {
      type: Object
    },

    disabled: {
      type: Boolean,
      default: false
    },

    classFor: {
      type: Function,
      default: classFor
    },

    columnActions: {
      type: Array,
      default: undefined
    },

    noTags: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.rowHeaderClass = (row) => {
      let ret = 'text-truncate col-6 align-self-center';
      if (row && (row.tag === 'NEW' || row.tags && row.tags.includes('NEW'))) {
        //console.log('row', row);
        ret += ' text-success';
      }
      return ret;
    };
  },

  data() {
    return {
      firstColumn: 0,
      visibleColumns: 3,
    };
  },

  computed: {
    columns() {
      return Object.values(this.value.columns);
    }
  },

  methods: {
    tagsFor(col) {
      let source = "Orig.Scon.";
      let type = "Tipo Scon."
      if (col.tags) {
        if (col.tags.includes('source:xbrl')) {
          source = "XBRL";
        } else if (col.tags.includes('source:manual')) {
          source = "Manuale";
        }
        if (col.tags.includes('type:depositato')) {
          type = "Depositato";
        } else if (col.tags.includes('type:provvisorio')) {
          type = "Provvisorio";
        } else if (col.tags.includes('type:previsionale')) {
          type = "Previsionale";
        }
      }
      return [
        { text: source, variant: 'warning' },
        { text: type, variant: 'primary' }
      ];
    },

    showVariation(row, columnIndex) {
      const table = this.value;
      const columns = Object.values(table.columns);
      return columnIndex > 0
          && table.values[row.name]
          && table.values[row.name][columns[columnIndex].name]
          && table.values[row.name][columns[columnIndex - 1].name];
    },

    computeVariation(row, columnIndex) {
      try {
        const table = this.value;
        const columns = Object.values(table.columns);
        const curr = table.values[row.name][columns[columnIndex].name];
        const prev = table.values[row.name][columns[columnIndex - 1].name];
        return (curr - prev) / Math.abs(prev) * 100;
      } catch (e) {
        return NaN;
      }
    },

    getClass(row, col) {
      const v = this.tableValue(row, col);
      return this.classFor(row, col, v);
    },

    tableValue(row, col) {
      const rowValues = this.value.values[row.name];
      return rowValues && rowValues[col.name];
    },

    valueChanged(row, col, v) {
      const table = { ...this.value };
      const values = { ...table.values };
      const rowValues = { ...values[row.name] };

      rowValues[col.name] = v;

      values[row.name] = rowValues;
      table.values = values;

      this.$emit('input', table);
    },

    previousColumn() {
      if (this.firstColumn > 0) {
        this.firstColumn--;
      }
    },

    nextColumn() {
      if (this.columns.length > this.visibleColumns) {
        this.firstColumn++;
      }
    }
  }
};
</script>
